import { createReducer } from '@reduxjs/toolkit';
import { updateUser, logoutUser, isRefresh, updateSubscription, updateSubscriptions } from '../actions';

const initialState = { };

export const userReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(updateUser, (state, action) => {
      return { ...action.payload };
    })
    .addCase(isRefresh, (state, action) => {
      return { ...state, ...action.payload };
    })
    .addCase(logoutUser, (state, action) => {
      return initialState;
    })
});

const subscriptionInitialState = { };

export const subscriptionReducer = createReducer(subscriptionInitialState, (builder) => {
  builder
    .addCase(updateSubscription, (state, action) => {
      return { ...action.payload };
    })
});

const subscriptionsInitialState = { };

export const subscriptionsReducer = createReducer(subscriptionsInitialState, (builder) => {
  builder
    .addCase(updateSubscriptions, (state, action) => {
      return { ...action.payload };
    })
});